module.exports = __webpack_public_path__ + "static/media/inf_33og34.f2335822.mp3";